module.exports = __webpack_public_path__ + "static/media/illustration.c0338a13.svg";